import Vue from "vue";
import vConsole  from 'vconsole';
import VueI18n from "vue-i18n";
import { ingame, dataURLtoFile, getSys, download, isMobile } from '@tencent/pa-cms-utils';
import html2canvas from 'html2canvas';
import Aegis from 'aegis-web-sdk';

import { getRoleInfo, saveRoleInfo, RoleInfo, getLoginedInitInfo, getReward, submitShare, submitSign } from "@/api/modules/page";
import { IsTest, getLang, switchLang, isInIntlBrowser, getSpecialBrowserType } from "@/utils/tools";
import { initServetime } from "@/api";
import { reportTlog } from "@/api/modules/report";
import { fb_app_id, REGISTER_URL, ProdServerMap, isHtm, MissionStatus, RoleCardStatus, presentMap } from "@/utils/const";
import { dynamicShare, share } from "@/utils/share";
import Login, { checkLogin } from "@/utils/login";
import './style.css'
import { setLanguageDialog, languageArr } from './utils/setLanguage'

Vue.use(VueI18n)
Vue.config.productionTip = false;
if (IsTest) {
  new vConsole();
}
new Aegis({
  id: 'KJmZxfqQpjKEmvPYaq', // 上报 id
  uin: Login.info()?.openid, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: 'https://rumt-sg.com',
  env: IsTest ? "test" : "production",
  api: {
    apiDetail: true,
  },
});
reportTlog({
  action: "summer_home_page",
  sub_action: "cm_vshow"
})

const DEFAULT_LANG = "en";

const CMSLanguage = {
  en : 'en',
  th : 'th',
  fr : 'fr',
  de : 'de',
  pt : 'pt-all',
  es : 'es',
  id : 'id',
  ja : 'ja',
  ko : 'ko',
}
// 语言路径
const allLanguageContext= require.context('./locales', false, /\**\.js$/);
const locales = allLanguageContext.keys().reduce((pre, fileName) => {
  const componentConfig = allLanguageContext(fileName)
  const name = fileName.replace(".js", "").replace("./", "");
  return {
    ...pre,
    [name]: componentConfig.default,
  }
}, {})
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: DEFAULT_LANG,
});
const LOCALE_KEY = "localeLanguage";

const getLangFromStorage = () => {
  const storeLang = window.localStorage.getItem(LOCALE_KEY);
  if (!storeLang) return;
  const lang = locales[storeLang as keyof typeof locales]
  if (lang === undefined) return;
  return storeLang;
}
export const setLocal = (language?: string|null) => {
  console.log("setLocal", language);
  let lang = language;
  if (lang === undefined || lang === null) {
    lang = getLangFromStorage();
  }
  if (!lang) return;
  window.localStorage.setItem(LOCALE_KEY, lang);
  i18n.locale = lang;
  // 静态Html 数据动态显示
  // document.title = i18n.t("title") as string;
  // const metas = document.getElementsByTagName("meta");
  // console.log('metas', metas)
  // const keywords = metas["keywords"];
  // const description = metas["description"];
  // if (keywords) {
  //   keywords.setAttribute("content", i18n.t("page.298"));
  // }
  // if (description) {
  //   description.setAttribute("content", i18n.t("page.299"));
  // }
};
const shareChannelMap = {
  en: ['twitter', 'facebook'],
  th: ['twitter', 'facebook'],
  ja: ['twitter', 'line'],
  ko: ['twitter'],
  zh: ['facebook', 'line'],
};
const urlLangType = getLang();
window.setLocal = setLocal;
setLocal(urlLangType);
const init = Vue.prototype._init;
Vue.prototype._init = function (options: any) {
  init.call(this, {
    i18n,
    ...options,
  });
};

// https://1024tools.com/timestamp utc+9
// const startTimestamp= 1691636400; // 2023-08-10 12:00:00
// 用于计算天数
const daysStartTimestamp= 1691658000; // 2023-08-10 18:00:00
const endTimestap= 1692197999; // 2023-08-16 23:59:59
// TODO test
const startTimestamp= 1690858800; // 2023-08-01 12:00:00
// const daysStartTimestamp= 1691197200; // 2023-08-05 10:00:00
// const endTimestap= 1692197999; // 2023-08-16 23:59:59

// 获取活动开启的天数
export function getActStartDays() {
  const diff = window.serverTime - daysStartTimestamp;
  const days =  Math.floor(diff / (60 * 60 * 24)) + 1;
  return days || 1
}
new Vue<any>({
  el: "#app",
  data() {
    return {
      languageArr,
      language: urlLangType,

      roleId: 0,
      areaId: 0,

      roleList: [],
      isLogin: checkLogin(),
      choosed: false,
      serverList: ProdServerMap,

      loading: false,
      
      isShare: false,
      roleCardId: -1,// 打开的角色卡片
      isInIntlBrowser,
      isHtm,

      recordTagList: [],
      siginInDays: 0,
      startDays: -1,
      userHasPresentList: [],
      showMask: false,
    }
  },
  computed: {
    languageText(){
      const lang = languageArr.find(lang =>lang.value === this.language)
      if (!lang) {
        const english = languageArr.find(lang =>lang.value === 'en')
        return english?.label
      }
      return lang.label;
    },
    roleName() {
      if (!this.roleId) return '';
      const role = this.roleList.find((role: RoleInfo) => role.role_id === this.roleId);
      if (!role) return '';
      return role.role_name;
    },
    showNv() {
      if (this.language === 'ko') return 'naver';
      if (isHtm || this.language === 'th') return 'facebook';
      return 'twitter';
    },
    rewardStaus() {
      const taskLen = 3;
      // 状态待补充 未完成 0 未领取 1 已领取2
      const statusMap = {
        unfinish: { class: 'btn-rew-gray', text: this.$t('claimable'), status: MissionStatus.Unfinish },
        unrecive: { class: 'btn-rew-active', text: this.$t('claimable'), status: MissionStatus.Unrecive },
        recived: { class: 'btn-rew-gray', text: this.$t('claimed'), status: MissionStatus.Recived },
      }
      const taskInfo = [];
      const needDays = [1, 3, 5];
      for(let i = 0; i < taskLen; i ++){
        const unfinishInfo = {
          ...statusMap.unfinish,
        }
        // 签到天数不到，返回 未完成
        if(needDays[i] > this.siginInDays) {
          taskInfo.push(unfinishInfo)
          continue;
        }
        // 奖励 对应的编号
        const presentId = presentMap[i];
        const isRecived = this.userHasPresentList.includes(presentId);
        if(isRecived) {
          taskInfo.push(statusMap.recived);
          continue;
        }
        taskInfo.push(statusMap.unrecive);
      }
      return taskInfo;
    },
    roleCardStatus() {
      // 每张卡片的状态
      const taskLen = 5;
      // 状态待补充 不可签到 0 未签到 1 已签到2
      const statusMap = {
        notAvailable: { class: '', status: RoleCardStatus.NotAvailable },
        canSign: { class: 'btn-clue--open', status: RoleCardStatus.CanSign},
        signed: { class: 'btn-clue--unlock', status: RoleCardStatus.Signed },
      }
      const roleCardInfo = [];

      for(let i = 0; i < taskLen; i ++){
        // console.log('this.startDays', this.startDays, i)
        // 活动开始后一天一个卡片， 此处id 与开启需要的天数相等
        // 开启天数不到，返回 未完成
        if(this.startDays < i + 1) {
          roleCardInfo.push(statusMap.notAvailable);
          continue;
        }
        // 开启天数已到 且未签，返回 未签到
        const isSinged = this.recordTagList.includes(String(i + 1));
        if (isSinged) {
          roleCardInfo.push(statusMap.signed);
          continue;
        }
        roleCardInfo.push(statusMap.canSign);
      }
      return roleCardInfo;
    },
    shareChannels() {
      return shareChannelMap[getLang()]
    }
  },
  watch: {
    language: {
      handler(lang, oldLang) {
        window.setLocal(lang);
        const langStr = lang.toUpperCase()
        const langObj = window.GLanguage[langStr]
        if (langObj['title']) {
          document.title = langObj['title']
        }
        window.initLang(langObj)
        window.$("body").addClass(`lang_${lang}`)
        window.$("body").removeClass(`lang_${oldLang}`)
      },
      immediate: true,
    },
    areaId(val) {
      if (!val || val === '0' || !checkLogin()) return;
      this.roleList = [];
      const role = this.areaRoleMap.get(val);
      if (role) {
        this.roleList = [role];
        return;
      }
      this.loading = true;
      getRoleInfo({area_id: val }).then((res) => {
        if (!res || res.code !== 0) return;
        const { data } = res;
        if (!data.get_role_info) return;
        const { get_role_info} = data;
        // 异步 可能 areaId已改变
        if (val !== this.areaId) {
          this.areaRoleMap.set(val, get_role_info);
          return
        }
        this.roleList = [get_role_info];
      }).finally(() => {
        this.loading = false;
      })
    },
    isShare(val) {
      if (!val) return;
      setTimeout(() => {
        // 存在异步图片资源未加载完
        this.dynamicShare();
      }, 400)
    },
  },
  async created(){
    window.downloadWallpaper = this.downloadWallpaper
    this.areaRoleMap = new Map();
    await Login.init()
    this.isLogin = checkLogin()
    await initServetime();
    await this.init();
    this.addMask();
  },
  mounted(){
    document.addEventListener('click', this.closeDialog);
    document.addEventListener('DOMContentLoaded', () => {
      (window as any).insertIntroVideo(this.language.toUpperCase());
      window.SharePage.initAudios(this.language.toUpperCase())
    });
  },
  methods: {
    async init() {
      this.startDays = getActStartDays()
      if (checkLogin()){
        // 登录了， 异步获取 绑定区服信息
        this.getLoginedInitInfo();
      }
    },
    // 活动过期蒙层
    addMask() {
      if (window.serverTime < startTimestamp || window.serverTime > endTimestap) {
        this.showMask = true;
      }
    },
    clcikMask() {
      if (window.serverTime < startTimestamp) {
        this.showMessage(this.$t('FlowHasNotBegin'))
        return;
      }
      if (window.serverTime > endTimestap) {
        this.showMessage(this.$t('FlowHasEnd'))
        return;
      }
      this.showMask = false;
    },
    showMessage(text: string) {
      window.showTips(text);
    },
    setLanguageDialog,
    setLanguage(event: Event) {
      event.stopPropagation();
      const lang = window.$(event.target).attr('value');
      this.closeDialog();
      // 切换语言条链接
      switchLang(lang);
    },
    closeDialog() {
      window.$('.nv_list').hide();
      window.$('.loginout_box').hide();
    },
    async register(){
      const target = `${REGISTER_URL}&redirect_url=${encodeURIComponent(
        window.location.href
      )}`;
      if (ingame.isInIntlBrowser) {
        ingame.openInBrowser(target);
      } else {
        window.open(target, '_blank');
      }
    },
    async submitRole(){
      if (this.loading) return;
      if (!checkLogin()) {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      if (!this.roleId || this.roleId === '0' || !this.areaId || this.areaId === '0') {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      this.loading = true;
      try {
        const res = await saveRoleInfo({
          area_id: this.areaId,
          role_id: this.roleId,
        });
        if(res && res.code === 601009) {
          window.location.reload()
          return
        }
        if (res && res.code == 0) {
          window.closeDialog();
          this.choosed = true;
          this.getLoginedInitInfo();
        }
      } finally {
        this.loading = false;
      }
    },
    async trigerAreaSelect(){
      if (this.choosed) {
        window.closeDialog('popArea');
        return;
      }
      this.areaId = this.serverList[0].id;
      window.TGDialogS('popArea');
    },
    clickLogin(){
      if (!this.checkLogin()) return;
      if (!this.choosed) {
        window.TGDialogS('popArea');
        return;
      }
    },
    logout() {
      Login.logout();
      window.location.reload()
    },
    checkLogin() {
      if (this.isLogin && this.choosed) return true;
      if (!this.isLogin){
        // 打开登录框
        Login.login(this.language).then(async res => {
          if (res && (res.ret as any) === 0) {
            this.isLogin = true;
            await this.getLoginedInitInfo();
          }
        });
        return false;
      }
      if (!this.choosed) {
        this.trigerAreaSelect()
        return false;
      }
      return false;
    },
    async getLoginedInitInfo() {
      if (!this.isLogin) return;
      await this.getLoginedInfo();
      this.trigerAreaSelect();
    },
    clickLogout(event: Event){
      event.stopPropagation();
      window.$('.loginout_box').show();
    },
    async clickSign(id: number) {
      if (!this.checkLogin()) return;
      // 活动开始后一天一个卡片， 此处id 与开启需要的天数相等
      const roleCardInfo = this.roleCardStatus[id];
      if (!roleCardInfo) return;
      reportTlog({
        action: "summer_role_card_btn",
        sub_action: "cm_click",
        ext_content: {
          role_id: id + 1,
        }
      })
      if (roleCardInfo.status === RoleCardStatus.NotAvailable) {
        this.showMessage(this.$t("SignedDayNotEnough"));
        return;
      };
      this.roleCardId = id + 1;
      if (roleCardInfo.status === RoleCardStatus.CanSign) {
        const res = await submitSign({ tag_id: String(id + 1)});
        if (res && res.code === 0)  {
          // window.$(".cont .c3").show().siblings().hide();
          // window.$(".btn-back").show();
          this.getLoginedInitInfo()
        }
        return
      }
      if (roleCardInfo.status === RoleCardStatus.Signed) {
        window.$(".cont .c3").show().siblings().hide();
        window.$('.halo').hide()
        window.$(`.btn-clue${id + 1}`).removeClass('btn-clue--open')
        var char = window.$(`.btn-clue${id + 1}`).attr('data-char');
        // 跳转 分享页面
        window.SharePage.fillPage(char, this.language.toUpperCase());
        // 先解锁彩蛋 才可分享
        window.$('.c3').on('click', '.daoju-con', () => {
          reportTlog({
            action: "summer_eggs_btn",
            sub_action: "cm_click",
            ext_content: {
              role_id: this.roleCardId,
            }
          })
          this.isShare = true;
        })
        return;
      }
    },
    async dynamicShare(){
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      this.isLoading = true;
      const img = await this.getBase64Image('.c3-inner.c2-inner-savedimg')
      this.img = img;
      const uid = `${this.language}_${this.roleCardId || ''}_20230810`;
      const shareImg = await this.getBase64Image('.landscape-shareimg', { scale: 1 })

      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      if (isHtm) {
        this.dynamicShareResult = {
          // 港澳台分享地址， 由dynamicShareResult覆盖 TODO
          share_url: "https://nikke.hotcool.tw/8316090448944164/",
        };
        this.isLoading = false
        return
      };
      try {
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const result = await dynamicShare({
          file: dataURLtoFile(shareImg, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.dynamicShareResult = result;
        console.log('result', result)
      } catch (e){
        this.showMessage(this.$t("serverError"))
      } finally{
        this.isLoading = false;
      }
    },
    async share(channel: string) {
      reportTlog({
        action: "summer_share_channel_btn",
        sub_action: "cm_click",
        ext_content: {
          role_id: this.roleCardId,
          channel_name: channel,
        }
      })
      if (!window.$('.c3 .c3-con .daoju-con').hasClass('daoju-con--show')) {
        return;
      }
      if (this.isLoading || !this.dynamicShareResult) {
        this.showMessage(this.$t("laodingPic"))
        return;
      }
      const res = await submitShare();
      if (!res || res.code !== 0) return;
      try{
        await share({
        ...this.dynamicShareResult,
        app_id: fb_app_id,
        title: this.$t("shareContent"),
        text: this.$t("shareContent"),
        hashtag: "#NIKKE",
        channel,
        });
      } catch(error) {
        console.log('share error', error)
      }
    },
    async getBase64Image(selector: string, options = { scale: 2 }){
      const dom = document.querySelector(selector) as HTMLElement;
      if (!dom) return;
      const canvas = await html2canvas(dom, {
        logging:false,
        useCORS:true, 
        ...options
      })
      return canvas.toDataURL("png"); // 获取生成的图片的url
    },
    downloadImage() {
      reportTlog({
        action: "summer_download_pic_btn",
        sub_action: "cm_click",
        ext_content: {
          role_id: this.roleCardId,
        }
      })
      if (!window.$('.c3 .c3-con .daoju-con').hasClass('daoju-con--show')) {
        return;
      }
      const browser = getSpecialBrowserType();
      // android 无法保存图片
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        if (this.loading || !this.dynamicShareResult) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        if (isHtm) {
          this.showMessage(this.$t("open_in_browser"));
          return
        }
        ingame.openInBrowser(this.dynamicShareResult.image_url);
      } else if (['facebook', 'line'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessage(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        if (!this.img) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        download({
          base64: this.img,
          filename: 'share.jpg',
        });
      }
    },
    async downloadWallpaper(id: number) {
      const img = await this.getBase64Image(`img[src="ossweb-img/showcase-big-img${id + 1}.jpg"]`);
      if (!img) return;
      const browser = getSpecialBrowserType();
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        if (isHtm) {
          this.showMessage(this.$t("open_in_browser"));
          return
        }
        const { origin, pathname } = location
        const imgUrl = `${origin}${pathname}ossweb-img/showcase-big-img${id + 1}.jpg`;
        ingame.openInBrowser(imgUrl);
      } else if (['facebook', 'line'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessage(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        download({
          base64: img,
          filename: `showcase-img${id + 1}.jpg`,
        });
      }
    },
    clickBack() {
      this.isShare = false
    },
    clickStart() {
      reportTlog({
        action: "summer_start_btn",
        sub_action: "cm_click",
      })
    },
    clickShare() {
      reportTlog({
        action: "summer_share_btn",
        sub_action: "cm_click",
        ext_content: {
          role_id: this.roleCardId,
        }
      })
    },
    async clickReward(id: number){
      if (this.rewardStaus.length < id) return;
      if (!this.checkLogin()) return;
      if (this.rewardLoading) return;
      try {
        this.rewardLoading = true;
        const taskInfo = this.rewardStaus[id];
        const { status } = taskInfo;
        if (status === MissionStatus.Recived ||  status === MissionStatus.Unfinish) return;
        const res = await getReward({ id });
        if (!res || res.code !== 0) return;
        // 领奖以后 更新
        this.getLoginedInitInfo();
        // TODO 多语言key
        this.showMessage(this.$t('claimSucess'));
      } finally {
        this.rewardLoading = false;
      }
    },
    async getLoginedInfo() {
      const res = await getLoginedInitInfo()
      if (!res || res.code !== 0) return;
      const { data } = res;
      const { get_saved_role_info, record_tag_list = [], siginin_days = 0, user_has_present_list = [] } = data;
      this.choosed = !!get_saved_role_info;
      if (get_saved_role_info) {
        const { area_id, role_id }  = get_saved_role_info || {};
        this.roleList = [get_saved_role_info];
        this.areaId = area_id;
        this.roleId = role_id;
        this.areaRoleMap.set(area_id, get_saved_role_info);
      } else {
        this.roleList = [];
        this.areaId = 0;
        this.roleId = 0;
      }
      this.recordTagList = record_tag_list;
      this.siginInDays = siginin_days;
      this.userHasPresentList = user_has_present_list;
    },
    getOpenTwitterLink(e: Event) {
      e.preventDefault();
      interface LinkMap {
        [key: string]: {
          pc: string;
          mobile: string;
        };
      }
      const linkMap: LinkMap = {
        en: {
          pc: 'https://twitter.com/NIKKE_en',
          mobile: 'https://twitter.com/NIKKE_en'
        },
        ja: {
          pc: 'https://twitter.com/NIKKE_japan',
          mobile: 'https://twitter.com/NIKKE_japan'
        },
        ko: {
          pc: 'https://game.naver.com/lounge/nikke/board/11',
          mobile: 'https://m.game.naver.com/lounge/nikke/board/11'
        }
      }
      const link = linkMap[getLang()];
      if (!link) return window.open('https://twitter.com/NIKKE_en', '_blank');
      if (isMobile()) return window.open(link.mobile, '_blank');
      return window.open(link.pc, '_blank');
    },
    getOpenFacebookLink(e: Event) {
      e.preventDefault();
      return window.open('https://www.facebook.com/TW.NIKKE/', '_blank');
    },
    getOpenNarLink(e: Event){
      e.preventDefault();
      return window.open('https://game.naver.com/lounge/nikke/board/11/', '_blank');
    },
    toPolicy(type: 'cookie' | 'privacy' = 'cookie') {
      const map = {
        cookie: this.$t('cookiesLink'),
        privacy: this.$t('privacyLink'),
      };
      const url = map[type]
      window.open(url, '_blank');
    }
  }
});
